<template>
  <side-bar>
    <template slot="links">
      <div class="container" role="tablist">
        <router-link :to="{ name: 'Home' }" class="navbar-item">
          <span>
            <font-awesome-icon icon="house-user" />
          </span>
          Home
        </router-link>

        <div
          v-for="(link_child, key) in plataforma"
          :key="key"
          class="navbar-item"
          role="tab"
        >
          <div v-b-toggle="'sidebar-item-' + key">
            <span>
              <font-awesome-icon
                :icon="link_child.icon"
                :class="link_child.class"
              />
            </span>
            {{ link_child.label }}
          </div>

          <b-collapse
            :id="'sidebar-item-' + key"
            accordion="sidebar-menu"
            role="tabpanel"
            class="navbar-item-submenu"
          >
            <div
              v-for="(link_child, key) in link_child.childrens"
              :key="key + 'second_key'"
              class=""
            >
              <b-nav-item :to="{ name: link_child.to }">
                <font-awesome-icon icon="angle-right" class="mr-2" />
                {{ link_child.label }}
              </b-nav-item>
            </div>
          </b-collapse>
        </div>
      </div>
    </template>
  </side-bar>
</template>

<script>
export default {
  name: "ArvoreSidebar",
  props: {},
  data() {
    return {
      plataforma: [
        {
          label: "Oportunidades",
          icon: "lightbulb",
          class: "nav-item-icon text-yellow ",
          childrens: [
            {
              label: "Oportunidades",
              to: "oportunidades_list",
              icon: "",
              class: "nav-item-icon text-yellow",
            },
            {
              label: "Importação de recursos",
              to: "oportunidades_import_select",
              icon: "",
              class: "nav-item-icon text-info",
            },
            {
              label: "Concedentes",
              to: "concedentes_list",
              icon: "",
              class: "nav-item-icon text-red",
            },
            {
              label: "Biblioteca de Arquivos",
              to: "files_list",
              icon: "",
              class: "nav-item-icon text-info",
            },
          ],
        },
        {
          label: "Cadastros Complementares",
          icon: "table",
          class: "nav-item-icon text-red ",
          childrens: [
            {
              label: "Áreas",
              to: "areas_list",
              icon: "map-marked-alt",
              class: "nav-item-icon text-orange",
            },
            { label: "Categorias", to: "categorias_list", icon: "", class: "" },
            {
              label: "Modelos de Contrapartidas",
              to: "contrapartidas_list",
              icon: "",
              class: "",
            },
            {
              label: "Origens",
              to: "tipos_concedentes_list",
              icon: "",
              class: "",
            },
            {
              label: "Tipos de Instituições",
              to: "tipos_instituicoes_list",
              icon: "",
              class: "",
            },
            { label: "Moedas", to: "moedas_list", icon: "", class: "" },
            {
              label: "Perguntas Frequentes",
              to: null,
              icon: "",
            },
          ],
        },
        {
          label: "Gestão de Parceiros",
          icon: "users",
          class: "text-info",
          childrens: [
            { label: "Visão Geral", to: "", icon: "", class: "" },
            { label: "Parceiros", to: "parceiros_list", icon: "", class: "" },
            {
              label: "Usuários",
              to: "users_list",
              icon: "",
              class: "",
            },
            {
              label: "Clientes",
              to: "clientes_list",
              icon: "",
              class: "",
            },
          ],
        },
        {
          label: "Gestão de Assinaturas",
          icon: "file-signature",
          class: "text-orange ",
          childrens: [
            // {
            //   label: "Assinaturas",
            //   to: "assinaturas_list",
            //   icon: "",
            //   class: "",
            // },
            { label: "Planos", to: "planos_list", icon: "", class: "" },
            // { label: "Tipos de Acesso", to: "", icon: "", class: "" },
            // { label: "Visão Geral / Relatórios", to: "", icon: "", class: "" },
          ],
        },
        {
          label: "Extratores",
          icon: "file-signature",
          class: "text-yellow",
          childrens: [
            { label: "Discricionárias e Legais", to: "extratores_list", icon: "", class: "" },
          ],
        },
        {
          label: "Ferramentas",
          icon: "wrench",
          class: "text-green ",
          childrens: [
            { label: "Relatorios", to: "relatorios_list", icon: "", class: "" },
            { label: "Envio de E-mail", to: "", icon: "", class: "" },
            { label: "MailGun", to: "", icon: "", class: "" },
            { label: "Google Analytics", to: "", icon: "", class: "" },
            { label: "Suporte Bag Sistemas", to: "", icon: "", class: "" },
          ],
        },
        {
          label: "Administração",
          icon: "toolbox",
          class: "blue-grey ",
          childrens: [
            {
              label: "Usuários Administrativos",
              to: "users_list_admin",
              icon: "",
              class: "",
            },
            {
              label: "Perfis de Usuários",
              to: "acl_list",
              icon: "",
              class: "",
            },
            {
              label: "CNPJ",
              to: "cnpjs_list",
              icon: "",
              class: "",
            },
          ],
        },
      ],
    };
  },

  computed: {
    showOrHidenArrow() {
      return this.plataforma.childrens && this.plataforma.childrens.length > 0;
    },
  },

  methods: {
    isActive(to) {
      return this.$route.name === to;
    },
  },
};
</script>
